export const ApprovalUserType = {
  REQUESTER: 'REQUESTER',
  APPROVER: 'APPROVER',
  NON_PARTICIPANT: 'NON_PARTICIPANT'
};